import PropTypes from 'prop-types'

const Stepper = ({ currentStep = 1, steps = [] }) => {
    const getWidth = () => {
        const breakpoint = 100 / steps.length
        return breakpoint * currentStep
    }

    return (
        <div className="w-full flex flex-col items-center">
            <div className="flex w-full lg:max-w-[540px] justify-center rounded-sm">
                <div
                    style={{ width: `${getWidth()}%` }}
                    className="bg-text lg:bg-white h-[8px] relative rounded-sm"
                >
                </div>
                <div className="flex-1 dark:bg-[#3F3F46] bg-[#E4E4E7] lg:bg-[#3F3F46] h-[8px] rounded-sm"></div>
            </div>
            <div className="hidden lg:flex justify-between mt-3 w-full max-w-[540px] px-5">
                {steps?.map((step, index) => (
                    <span
                        key={step}
                        className={`${
                            index + 1 === currentStep
                            ? 'text-[#fff]  '
                            : '!text-[#A0A0AB] '
                        } text-[#fff] text-sm font-inter font-semibold uppercase leading-none tracking-tight`}
                    >
                        {step}
                    </span>
                ))}
            </div>
        </div>
    )
}

Stepper.propTypes = {
    currentStep: PropTypes.number.isRequired,
    steps: PropTypes.array.isRequired,
}

export default Stepper
